<div class="btn btn-danger btn-helper" (click)="_abrirAyuda()">
    <img src="assets/images/iconos/{{iconoAyuda}}"><br/>
    <label>Fuente de energía</label>
</div>

